export default __webpack_public_path__ + "static/media/innovation.64247700.png";